import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./part-exchange-menu.module.css";
import { partExchangeSnippets, partExchangeFAQs } from "../../../data/part-exchange";
import { ListSnippetItem } from "../list-snippet-item/list-snippet-item";
import { ListItem } from "../list-item/list-item";
import { ListWrapper } from "../list-wrapper/list-wrapper";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { parentLinks } from "../../../data/parent-menu";
import { ExternalLink } from "../../../assets/external-link";
export var PartExchangeMenu = function(param) {
    var setShouldShowMobileMenu = param.setShouldShowMobileMenu, isMobile = param.isMobile, handleFaqClick = param.handleFaqClick;
    var logicStore = useContext(SharedUiHeaderV2Context).logicStore;
    var handleTrackEvent = logicStore.handleTrackEvent;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            partExchangeSnippets && /*#__PURE__*/ _jsx("nav", {
                children: partExchangeSnippets.map(function(snippet) {
                    return /*#__PURE__*/ _jsx(ListSnippetItem, _object_spread_props(_object_spread({
                        isMobile: isMobile,
                        heading: snippet.heading,
                        snippet: snippet.snippet,
                        linkText: snippet.linkText,
                        href: snippet.href,
                        image: snippet.image,
                        alt: snippet.alt
                    }, snippet.externalLink && {
                        customIcon: /*#__PURE__*/ _jsx(ExternalLink, {})
                    }), {
                        handleTrackEvent: function() {
                            return handleTrackEvent({
                                name: "click",
                                category: "mega menu",
                                label: parentLinks.PARTEXCHANGE,
                                action: snippet.trackingTitle,
                                value: snippet.linkText
                            });
                        }
                    }), snippet.heading);
                })
            }),
            /*#__PURE__*/ _jsx("nav", {
                className: styles.container,
                children: /*#__PURE__*/ _jsx(ListWrapper, {
                    heading: "FAQs",
                    urlText: "Go to help and support",
                    href: "/support",
                    isListCard: true,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.PARTEXCHANGE,
                            action: "FAQ",
                            value: "Go to help and support"
                        });
                    },
                    children: /*#__PURE__*/ _jsx(_Fragment, {
                        children: partExchangeFAQs.map(function(faq) {
                            return /*#__PURE__*/ _jsx("li", {
                                className: styles.faqList,
                                children: /*#__PURE__*/ _jsx(ListItem, {
                                    label: faq.label,
                                    href: faq.href,
                                    ariaLabel: faq.ariaLabel,
                                    handleClickEvent: function() {
                                        handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.PARTEXCHANGE,
                                            action: "FAQ",
                                            value: faq.label
                                        });
                                        // handleFaqClick solve the scroll issue on desktop
                                        handleFaqClick && handleFaqClick(null);
                                        if (setShouldShowMobileMenu) {
                                            setShouldShowMobileMenu();
                                        }
                                    }
                                })
                            }, faq.label);
                        })
                    })
                })
            })
        ]
    });
};
